(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/legal-info/views/login-check.js') >= 0) return;  svs.modules.push('/modules/legal-info/views/login-check.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.legal_info=_svs.legal_info||{};
_svs.legal_info.templates=_svs.legal_info.templates||{};
svs.legal_info.templates.login_check = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"containerRegion\" class=\"js-react-container\"></div>\n";
},"useData":true});
Handlebars.partials['svs-legal_info-login_check'] = svs.legal_info.templates.login_check;
})(svs, Handlebars);


 })(window);